<template>
  <div>
    <el-dialog  :title="$t('Bank_məlumatları')"  :visible.sync="showModal" width="40%" top="5vh" append-to-body
      :close-on-press-escape="false" :close-on-click-modal="false">
      <el-form :rules="rules" :model="item" ref="bank" label-width="120px" :label-position="labelPosition" size="small">
        <div class="row" style="margin-top: -20px;">
          <div class="col-12">
            <el-form-item :label="$t('Banklar')" prop="bankId">
              <banks v-model="item.bankId" />
            </el-form-item>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <el-form-item :label="$t('Hesab_nömrəsi')" prop="accountNumber">
              <el-input  v-mask="'XXXXXXXXXXXXXXXXXXXXXXXXXXXX'" v-model="item.accountNumber"></el-input>
            </el-form-item>
          </div>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button  size="small" type="primary" @click="clickSave">{{$t('Yadda_saxla')}}</el-button>
        <el-button size="small"  @click="showModal = false">{{$t('İmtina')}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Banks from "../components/Banks.vue";
import { UpdateClaimAct } from "../../services/claim";
import { mask } from "vue-the-mask";
import { labelPosition } from "../../services/helper";

export default {
  directives: {
    mask,
  },
  components: {
    Banks,
  },
  data() {
    
    return {
      showModal: false,
      item: {},
      uid: this.$store.state.user.id,
      labelPosition: labelPosition,
      rules: {
        accountNumber: [
          {
            required: true,
            message: this.$t('Sütunmütləqdir'),
            trigger: "change",
          },
          {
            validator: (rule, value, callback) => {
              if (value && value.toString().length !== 28) {
                callback(new Error(this.$t('Hesab_nömrəsi_28_rəqəmdən_ibarət_olmalıdır')));
              } else {
                callback();
              }
            },
            trigger: "change",
          }
        ],
      }
    };
  },
  methods: {
    edit(item) {
      this.item = item;
      this.showModal = true;
    },
    clickSave() {
      this.$refs["bank"].validate((valid) => {
        if (!valid) {
          this.$message({
            type: "warning",
            message: this.$t('Hesab_nömrəsi_qeyd_olunmayıb'),
          });
          return false;
        } else {
          this.save();
        }
      });
    },
    save() {
      this.item.commandUserId = this.uid
      UpdateClaimAct(this.item).then((response) => {
        if (response.data) {
          if (!response.data.isSuccess) {
            this.$message({
              type: "error",
              message: response.data.errors[0]
                ? response.data.errors[0]
                : this.$t('Səhv_əməliyyat'),
            });
          } else {
            this.$emit("refresh");
            this.showModal = false;
            this.$message({
              type: "success",
              message: this.$t('Uğurlu_əməliyyat'),
            });
          }
        } else {
          this.$message({
            type: "error",
            message: this.$t('Səhv_əməliyyat'),
          });
        }
      });
    },
  },
};
</script>

<style scoped></style>
